module.exports = __webpack_public_path__ + "img/caijing.aa9c37b7.png";